export default [
  {
    path: "/manage-center",
    component: () => import("./moduleLayout.vue"),
    children: [
      {
        path: "requests-archives",
        name: "requests-archives",
        props: true,
        component: () =>
          import("./pages/requests/requests-page/archives/index.vue"),
      },

      {
        path: "bookings-awareness-sessions",
        name: "bookings-awareness-sessions",
        props: true,
        component: () =>
          import("./pages/bookings/bookings-page/events-activity/index.vue"),
      },
      {
        path: "booking-awareness-sessions/:id",
        name: "booking-awareness-sessions",
        props: true,
        component: () =>
          import(
            "./pages/bookings/bookings-page/events-activity/users-event.vue"
          ),
      },
      {
        path: "bookings-interactive-museum",
        name: "bookings-interactive-museum",
        props: true,
        component: () =>
          import("./pages/bookings/bookings-page/events-activity/index.vue"),
      },
      {
        path: "booking-interactive-museum/:id",
        name: "booking-interactive-museum",
        props: true,
        component: () =>
          import(
            "./pages/bookings/bookings-page/events-activity/users-event.vue"
          ),
      },
      {
        path: "bookings-training-heritage",
        name: "bookings-training-heritage",
        props: true,
        component: () =>
          import("./pages/bookings/bookings-page/events-activity/index.vue"),
      },
      {
        path: "booking-training-heritage/:id",
        name: "booking-training-heritage",
        props: true,
        component: () =>
          import(
            "./pages/bookings/bookings-page/events-activity/users-event.vue"
          ),
      },

      {
        path: "bookings-activites",
        name: "bookings-activites",
        props: true,
        component: () =>
          import("./pages/bookings/bookings-page/events-activity/index.vue"),
      },
      {
        path: "bookings-activite/:id",
        name: "bookings-activite",
        props: true,
        component: () =>
          import(
            "./pages/bookings/bookings-page/events-activity/users-event.vue"
          ),
      },
      {
        path: "bookings-events",
        name: "bookings-events",
        props: true,
        component: () =>
          import("./pages/bookings/bookings-page/events-activity/index.vue"),
      },
      {
        path: "bookings-event/:id",
        name: "bookings-event",
        props: true,
        component: () =>
          import(
            "./pages/bookings/bookings-page/events-activity/users-event.vue"
          ),
      },
      {
        path: "bookings-halls",
        name: "bookings-halls",
        props: true,
        component: () =>
          import("./pages/bookings/bookings-page/halls/index.vue"),
      },
      {
        path: "bookings-procedure",
        name: "bookings-procedure",
        props: true,
        component: () =>
          import("./pages/bookings/bookings-page/procedure/index.vue"),
      },
      {
        path: "/reception",
        name: "reception",
        props: true,
        component: () => import("./pages/reception/index.vue"),
      },
      {
        path: "/halls-details",
        name: "halls-details",
        props: true,
        component: () => import("./pages/reception/detilsHalls.vue"),
      },
      {
        path: "/halls-occupancy",
        name: "halls-occupancy",
        props: true,
        component: () => import("./pages/halls-occupancy/index.vue"),
      },
      {
        path: "/manage-evaluation",
        name: "manage-evaluation",
        props: true,
        component: () => import("./pages/evaluation/index.vue"),
      },
      {
        path: "/manage-services",
        name: "manage-services",
        props: true,
        component: () => import("./pages/services/index.vue"),
      },

      {
        path: "/office",
        name: "office",
        props: true,
        component: () => import("./pages/office/index.vue"),
      },      
      
      {
        path: "/visitors",
        name: "visitors",
        props: true,
        component: () => import("./pages/visitors/index.vue"),
      },     
      {
        path: "general-information",
        name: "general-information",
        component: () => import("./pages/legal-awareness/pages/general-information/index.vue"),
        props: true,
      },
      {
        path: "community-initiative",
        name: "community-initiative",
        component: () => import("./pages/community-services/pages/community-initiative/index.vue"),
        props: true,
      },
      {
        path: "community-committees",
        name: "community-committees",
        component: () => import("./pages/community-services/pages/community-committees/index.vue"),
        props: true,
      },
      {
        path: "mayors",
        name: "mayors",
        component: () => import("./pages/community-services/pages/mayors/index.vue"),
        props: true,
      },
      {
        path: "recording-studio",
        name: "recording-studio",
        component: ()=> import("./pages/bookings/bookings-page/halls/index.vue")
      },
      {
        path: "training-heritage",
        name: "training-heritage",
        component: ()=> import("./pages/cultural-services/pages/training-heritage/index.vue")
      },
      {
        path: "interactive-museum",
        name: "interactive-museum",
        component: ()=> import("./pages/cultural-services/pages/interactive-museum/index.vue")
      },
      {
        path: "financial-products",
        name: "financial-products",
        component: ()=> import("./pages/financial-products/index.vue")
      },
      {
        path: "self-tourist-tours",
        name: "self-tourist-tours",
        component: ()=> import("./pages/discover-ancient-city/pages/self-tourist-tours/index.vue")
      },
      {
        path: "tourist-facilities",
        name: "tourist-facilities",
        component: ()=> import("./pages/discover-ancient-city/pages/tourist-facilities/index.vue")
      },
      {
        path: "main-attraction",
        name: "main-attraction",
        component: ()=> import("./pages/discover-ancient-city/pages/main-attraction/index.vue")
      },
    ],
  },
];
